import React, { useState } from 'react';
import { getAvatarColor } from '../compartidos/utils';
import { enviarSolicitudProceso } from '../../servicios/notificacionesService';

function ModalProcesoSubcontrato({
  showModal, selectedTask, selectedStage,
  closeStageModal, handleFileUpload,
  stageFiles, openFileViewer, downloadFile, removeFile,
  processNoAplica, setProcessNoAplica,
  stageComments, removeComment,
  currentComment, setCurrentComment,
  saveStageData, completedProcesses,
  revertTaskProcess, isRevertingProcess,
  markProcessComplete, isSavingProcess,
  teamMembers, projectName, usuarioActual
}) {
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [emailDestinatarios, setEmailDestinatarios] = useState(new Set());
  const [emailLibre, setEmailLibre] = useState('');
  const [emailMensaje, setEmailMensaje] = useState('');
  const [enviandoCorreo, setEnviandoCorreo] = useState(false);
  const [emailEnviado, setEmailEnviado] = useState(false);

  if (!showModal || !selectedTask || !selectedStage) return null;

  const toggleDestinatario = (memberId) => {
    setEmailDestinatarios(prev => {
      const next = new Set(prev);
      if (next.has(memberId)) next.delete(memberId);
      else next.add(memberId);
      return next;
    });
  };

  const handleEnviarSolicitud = async () => {
    const destinatarios = (teamMembers || []).filter(m => emailDestinatarios.has(m.id || m._id)).map(m => ({ nombre: m.name || m.nombre, email: m.email }));
    if (destinatarios.length === 0 && !emailLibre.trim()) {
      alert('Selecciona al menos un destinatario o ingresa un email');
      return;
    }
    if (!emailMensaje.trim()) {
      alert('Escribe un mensaje para la solicitud');
      return;
    }
    setEnviandoCorreo(true);
    try {
      await enviarSolicitudProceso({
        destinatarios,
        emailLibre: emailLibre.trim() || undefined,
        contexto: {
          tipo: 'subcontrato',
          nombreItem: selectedTask.text,
          especialidad: selectedTask.specialty || '',
          etapa: selectedStage,
          projectName: projectName || 'Proyecto',
          remitente: usuarioActual?.nombre || usuarioActual?.email || 'Un miembro del equipo'
        },
        mensaje: emailMensaje.trim()
      });
      setEmailEnviado(true);
      setEmailMensaje('');
      setEmailDestinatarios(new Set());
      setEmailLibre('');
      setTimeout(() => setEmailEnviado(false), 4000);
    } catch (err) {
      alert('Error al enviar: ' + (err.response?.data?.error || err.message));
    } finally {
      setEnviandoCorreo(false);
    }
  };

  const fileKey = `${selectedTask.id}-${selectedStage}`;

  return (
    <div className="modal-overlay" onClick={closeStageModal} style={{ background: 'transparent', justifyContent: 'flex-end', pointerEvents: 'none' }}>
      <div className="modal-content proceso-modal" onClick={(e) => e.stopPropagation()} style={{ width: '480px', height: '100vh', borderRadius: '0', margin: '0', position: 'fixed', right: '0', top: '0', pointerEvents: 'all' }}>
        <div className="modal-header etapa-modal-header">
          <h3>Etapa: {selectedStage.toUpperCase()}</h3>
          <button className="modal-close" onClick={closeStageModal}>✕</button>
        </div>

        <div className="modal-body">
          <div className="modal-section">
            <h4>Información del Subcontrato</h4>
            <p><strong>Subcontrato:</strong> {selectedTask.text}</p>
            <p><strong>Especialidad:</strong> {selectedTask.specialty}</p>
          </div>

          <div className="modal-section">
            <h4>Cargar Archivos</h4>
            <input
              type="file"
              accept=".pdf,.xlsx,.xls,.csv"
              multiple
              onChange={handleFileUpload}
              className="file-input"
            />
            <p className="file-info">Puedes cargar múltiples archivos (PDF, Excel, CSV)</p>

            {stageFiles[fileKey] && (
              <div className="files-list">
                <h5>Archivos cargados:</h5>
                <ul>
                  {stageFiles[fileKey].map((file, index) => (
                    <li key={index} className="file-item">
                      <span>{file.name}</span>
                      <div className="file-actions">
                        <button
                          className="file-open-btn"
                          onClick={() => openFileViewer(file)}
                          title="Abrir archivo"
                        >
                          Ver
                        </button>
                        <button
                          className="file-download-btn"
                          onClick={() => downloadFile(file)}
                          title="Descargar archivo"
                        >
                          Descargar
                        </button>
                        <button
                          className="file-remove-btn"
                          onClick={() => removeFile(fileKey, index)}
                          title="Eliminar"
                        >
                          ✕
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <label className="checkbox-label" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', marginTop: '10px' }}>
              <input
                type="checkbox"
                checked={processNoAplica}
                onChange={(e) => setProcessNoAplica(e.target.checked)}
                style={{ marginRight: '8px', cursor: 'pointer' }}
              />
              <span style={{ fontWeight: '600' }}>
                Este proceso no aplica (completar sin archivos)
              </span>
            </label>
          </div>

          <div className="modal-section">
            <h4>Comentarios</h4>

            {stageComments[fileKey] && stageComments[fileKey].length > 0 && (
              <div className="comments-chat">
                {stageComments[fileKey].map((comment) => (
                  <div key={comment.id} className="chat-message">
                    <div className="message-header">
                      <span className="message-time">{comment.timestamp}</span>
                      <button
                        className="message-delete-btn"
                        onClick={() => removeComment(fileKey, comment.id)}
                        title="Eliminar comentario"
                      >
                        ✕
                      </button>
                    </div>
                    <p className="message-text">{comment.text}</p>
                  </div>
                ))}
              </div>
            )}

            <div className="comment-input-section">
              <textarea
                className="comment-textarea"
                placeholder="Agrega un comentario sobre esta etapa..."
                value={currentComment}
                onChange={(e) => setCurrentComment(e.target.value)}
                rows="3"
              />
              <button
                className="btn-add-comment"
                onClick={saveStageData}
                disabled={!currentComment.trim()}
              >
                Agregar Comentario
              </button>
            </div>
          </div>

          {/* Envío de solicitud por correo */}
          <div className="modal-section">
            <button
              onClick={() => setShowEmailForm(!showEmailForm)}
              style={{
                width: '100%', padding: '10px 16px', background: '#111827',
                color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer',
                fontWeight: '600', fontSize: '13px', display: 'flex', alignItems: 'center',
                justifyContent: 'center', gap: '8px'
              }}
            >
              Enviar Solicitud por Correo {showEmailForm ? '▲' : '▼'}
            </button>

            {showEmailForm && (
              <div style={{ marginTop: '12px', background: '#f9fafb', borderRadius: '6px', padding: '16px' }}>
                {/* Contexto automático */}
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '12px' }}>
                  <span style={{ fontSize: '11px', background: '#e5e7eb', color: '#111827', padding: '2px 8px', borderRadius: '4px', fontWeight: '600' }}>{selectedTask.text}</span>
                  <span style={{ fontSize: '11px', background: '#e5e7eb', color: '#111827', padding: '2px 8px', borderRadius: '4px', fontWeight: '600' }}>{selectedStage}</span>
                  {selectedTask.specialty && <span style={{ fontSize: '11px', background: '#e5e7eb', color: '#111827', padding: '2px 8px', borderRadius: '4px', fontWeight: '600' }}>{selectedTask.specialty}</span>}
                </div>

                {/* Destinatarios - miembros del equipo */}
                <p style={{ margin: '0 0 8px 0', fontSize: '12px', fontWeight: '600', color: '#374151' }}>Destinatarios:</p>
                <div style={{ maxHeight: '140px', overflowY: 'auto', marginBottom: '10px' }}>
                  {(teamMembers || []).map((member, idx) => {
                    const mid = member.id || member._id;
                    return (
                      <label key={mid} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 8px', cursor: 'pointer', borderRadius: '6px', background: emailDestinatarios.has(mid) ? '#e5e7eb' : 'transparent', marginBottom: '2px' }}>
                        <input type="checkbox" checked={emailDestinatarios.has(mid)} onChange={() => toggleDestinatario(mid)} style={{ cursor: 'pointer' }} />
                        <span style={{ width: '24px', height: '24px', borderRadius: '50%', background: getAvatarColor(idx), color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '700', flexShrink: 0 }}>
                          {(member.name || member.nombre || '?').charAt(0).toUpperCase()}
                        </span>
                        <span style={{ fontSize: '13px', color: '#1a1a1a' }}>{member.name || member.nombre}</span>
                        {(member.role || member.cargo) && <span style={{ fontSize: '11px', color: '#9ca3af' }}>({member.role || member.cargo})</span>}
                      </label>
                    );
                  })}
                </div>

                {/* Email libre */}
                <input
                  type="email"
                  placeholder="Email adicional externo (opcional)"
                  value={emailLibre}
                  onChange={(e) => setEmailLibre(e.target.value)}
                  className="file-input"
                  style={{ width: '100%', marginBottom: '10px', fontSize: '13px' }}
                />

                {/* Mensaje */}
                <textarea
                  placeholder="Escribe tu solicitud o mensaje..."
                  value={emailMensaje}
                  onChange={(e) => setEmailMensaje(e.target.value)}
                  rows="3"
                  className="comment-textarea"
                  style={{ marginBottom: '10px' }}
                />

                {/* Botón enviar + feedback */}
                <button
                  onClick={handleEnviarSolicitud}
                  disabled={enviandoCorreo || (emailDestinatarios.size === 0 && !emailLibre.trim()) || !emailMensaje.trim()}
                  style={{
                    width: '100%', padding: '10px', border: 'none', borderRadius: '6px',
                    background: enviandoCorreo ? '#94a3b8' : emailEnviado ? '#16a34a' : '#111827',
                    color: '#fff', fontWeight: '600', fontSize: '13px', cursor: enviandoCorreo ? 'wait' : 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
                  }}
                >
                  {enviandoCorreo ? <><div className="spinner" style={{ width: '16px', height: '16px' }}></div> Enviando...</> : emailEnviado ? 'Correo enviado correctamente' : 'Enviar Solicitud'}
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={closeStageModal}>Cerrar</button>
          {completedProcesses[fileKey] && (
            <button
              className="btn-revert"
              onClick={revertTaskProcess}
              disabled={isRevertingProcess}
              title="Descompletar este proceso y eliminar todos sus documentos"
            >
              {isRevertingProcess ? <div className="spinner"></div> : 'Descompletar Proceso'}
            </button>
          )}
          <button
            className="btn-save"
            onClick={markProcessComplete}
            disabled={isSavingProcess || (
              !processNoAplica &&
              (!stageFiles[fileKey] || stageFiles[fileKey].length === 0) &&
              (!stageComments[fileKey] || stageComments[fileKey].length === 0)
            )}
          >
            {isSavingProcess ? <div className="spinner"></div> : 'Guardar Proceso'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalProcesoSubcontrato;
